import { api } from '../client/axiosClient';
import { ProgramVersionDto } from '../types/dtos/program';
import { BaseService } from './base.service';
import { CustomResponseEntity, PaginationParams } from '../types/common';

const DATASOURCE_URI = '/api';
const VERSION = 'v1';

/**
 * Fetch detailed program versions for a program.
 * @param _organizationId - Deprecated: Organization ID (no longer used, kept for backward compatibility)
 * @param programId - Program UUID
 * @deprecated Use ProgramVersionService instead
 */
export const fetchProgramVersionsDetailed = async (_organizationId: string, programId: string): Promise<ProgramVersionDto[]> => {
  // axios interceptor already unwraps response.data, so response is the CustomResponseEntity
  const response = await api.get<CustomResponseEntity<ProgramVersionDto[]>>(`${DATASOURCE_URI}/${VERSION}/programs/${programId}/versions/detailed`);
  return response.data || [];
};

/**
 * Fetch program versions.
 * @deprecated Use ProgramVersionService instead
 */
export const fetchProgramVersions = async (): Promise<ProgramVersionDto[]> => {
  // Adjust endpoint as needed to match backend
  const res = await api.get<ProgramVersionDto[]>('/api/v1/program-versions');
  return res;
};

/**
 * ProgramVersionService handles CRUD operations for program versions.
 *
 * URL Pattern: /api/v1/programs/{programId}/versions
 * Organization context is provided via X-Organization-Id header (injected by axiosClient).
 *
 * Migration: The organizationId parameter has been removed from URL paths. The backend
 * extracts organization context from the X-Organization-Id header for tenant scoping.
 *
 * VAL-PRG-004: ProgramVersion List with X-Organization-Id Header
 *
 * @param _organizationId - Deprecated: Organization ID (no longer used, kept for backward compatibility)
 * @param programId - Parent program UUID for nested resource path
 */
export class ProgramVersionService extends BaseService<ProgramVersionDto> {
  /**
   * @param _organizationId - Deprecated: Organization ID (no longer used, kept for backward compatibility)
   * @param programId - Parent program UUID for nested resource path
   */
  constructor(_organizationId: string, programId: string) {
    super(`/api/v1/programs/${programId}/versions`);
  }

  findAll(params?: PaginationParams & { isActive?: boolean }): Promise<CustomResponseEntity<ProgramVersionDto[]>> {
    return super.findAll(params);
  }
}

/**
 * Factory function to create a ProgramVersionService instance
 * @param _organizationId - Deprecated: Organization ID (no longer used, kept for backward compatibility)
 * @param programId - Parent program UUID for nested resource path
 */
export const createProgramVersionService = (
  _organizationId: string,
  programId: string
) => new ProgramVersionService(_organizationId, programId); 